import { gql } from 'graphql-request';


export const COMPANY_PROFILE_INVITATION_FRAGMENT = gql`
    fragment CompanyProfileInvitationFields on CompanyProfileInvitation {
        profileId
        email
        name
        state
        creationDate
        sentDate
        acceptedDate
    }
`